export function printHtml (html) {
  return new Promise((resolve) => {
    const iframe = document.createElement('iframe')
    iframe.setAttribute('aria-hidden', 'true')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = '0'

    let finished = false
    const cleanup = () => {
      if (finished) return
      finished = true
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe)
      }
      resolve()
    }

    document.body.appendChild(iframe)

    const doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document)
    if (!doc) return cleanup()

    doc.open()
    doc.write(html)
    doc.close()

    const pendentes = Array.from(doc.images)
      .filter((img) => !img.complete)
      .map((img) => new Promise((resolve) => {
        img.onload = resolve
        img.onerror = resolve
      }))

    Promise.all(pendentes).then(() => {
      const win = iframe.contentWindow
      if (!win) return cleanup()

      win.onafterprint = cleanup
      win.focus()
      win.print()
      setTimeout(cleanup, 60000)
    })
  })
}
